import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { Button } from "../Button/Button";
import { Brand } from "../Brand/Brand";

const ButtonsContent = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;

const ItemLink = styled(Link)`
  width: 45%;
  .button {
    width: 100%;
    padding: 20px 15px;
    margin-bottom: 20px;
  }
`;

function AzkarMenu({ pageName, AzkarList }) {
  return (
    <>
      <Brand brand={pageName} />
      <ButtonsContent>
        {AzkarList.map((item) => (
          <ItemLink to={item.path}>
            <Button btnStyle="btn--hovered">{item.name}</Button>
          </ItemLink>
        ))}
      </ButtonsContent>
    </>
  );
}

export default AzkarMenu;
